import React, { useEffect } from "react";
import { Button, Form, Input, DatePicker, Select, TreeSelect } from "antd";
import { useModel } from "../../../models/index";
import { SwapOutlined } from '@ant-design/icons';
import { useState } from "react";
const { RangePicker } = DatePicker;
const rangeConfig = {
    rules: [{ type: 'array', required: false, message: '请选择制单时间!' }],
};
export default function () {
    const [form] = Form.useForm();

    const [{ customerDict }, { }] = useModel("cmDict");

    const [{ searchParam, searcnPage }, { setSearchParam, resetSearchParam, loadListDetail }] = useModel("customerSaleModel");
    const [seekCut, serSeekCut] = useState(true)
    /*useEffect(() => {
        form.setFieldsValue(searchParam);
    }, [searchParam]);*/

    useEffect(() => {
        onReset();
    }, []);

    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searcnPage
        const { customerName } = searchParam;
        // return console.log(customerName,searchParam,customerDict)
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum,
            customerName,
        }
        loadListDetail({ showMsg: true, data,seekCut});
    }
    const onReset = () => {
        form.resetFields();
        resetSearchParam();
        let data = {
            pageSize: 15,
            pageNum: 1,
        }
        loadListDetail({ showMsg: true, data })
    }
    const cutSearch = () => {
        serSeekCut(!seekCut)
    }
    return (
        <Form
            form={form}
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            {/* <Button
                type="primary"
                className="margin-right-16"
                onClick={cutSearch}
            >
                {seekCut ? "精确搜索" : "模糊搜索"}<SwapOutlined />
            </Button> */}
            <Form.Item
                name="customerName"
                label="客户名称"
            >
                {seekCut?
                    <Input placeholder="输入客户名称" style={{ width: "200px" }} />:
                    <Select
                    style={{ width: "200px" }}
                    showSearch
                    allowClear={true}
                    onSearch={(value) => {  }}
                    placeholder="选择客户"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={customerDict}
                    dropdownClassName="dark-select"
                />}
            </Form.Item>
            <Form.Item name="checkTime" label="结算日期" {...rangeConfig}>
                <RangePicker style={{ width: "300px" }} />
            </Form.Item>
            
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="button"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}